export const JWT_TOKEN_KEY = 'JWT_TOKEN_KEY';

//Authentication helper file used to store/delete token and deal with headers
const Auth = {
	storeToken(token) {
		return localStorage.setItem('JWT_TOKEN_KEY', token);
	},

	clearSession() {
		localStorage.removeItem('JWT_TOKEN_KEY');
		localStorage.removeItem('USER_ID_TOKEN');
		localStorage.removeItem('USER_TYPE');
		localStorage.removeItem('USER_CATG');
		localStorage.removeItem('USER_CATG_TYPE');
		localStorage.removeItem('USER_PRIVILEGES');
		localStorage.removeItem('ZOOM_REFRESH_TOKEN');
	},

	getToken() {
		return localStorage.getItem(JWT_TOKEN_KEY);
	},

	async getAccessToken() {
		const token = this.getToken();
		return {
			Authorization: `Bearer ${token}`
		};
	},

	getContentType() {
		return {
			'Content-Type': 'application/json'
		};
	},

	async getHeaders() {
		const token = this.getToken();
		return {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		};
	},

	async getUploadHeaders() {
		const token = this.getToken();
		return {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'fileType'
		};
	},

	isLoggedIn() {
		return localStorage.getItem('JWT_TOKEN_KEY');
	},

};

export default Auth;
